import React, {useMemo} from 'react';

import {useAddToRecentsMutation} from '../hooks/requests/use-recents-query';
import {useDocumentHistoryQuery} from '../../../../providers/version/document-history-query';

interface Params {
    documentId: string;
    revisionId?: string;
    documentInfo?: ViewModeDoc;
}

export const useEditorModel = ({documentId, revisionId, documentInfo}: Params) => {
    const documentHistoryQuery = useDocumentHistoryQuery(documentId, {enabled: false});

    const useAddToRecentMutation = useAddToRecentsMutation();

    const currentRevision = useMemo(() => {
        if (revisionId) {
            return revisionId;
        }

        if (documentInfo) {
            return documentInfo.revision;
        }
    }, [documentInfo, revisionId]);

    const revisionInfo = useMemo(() => {
        if (documentHistoryQuery.data && documentInfo) {
            return documentHistoryQuery.data.find(({revision}) => revision === currentRevision);
        }
    }, [documentHistoryQuery.data, documentInfo, currentRevision]);

    React.useEffect(() => {
        if (documentInfo) {
            useAddToRecentMutation.mutate(documentInfo);

            if (documentInfo.revision) {
                documentHistoryQuery.refetch();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentInfo]);

    return {
        isLoadingLastRevision: documentHistoryQuery.isLoading,
        revisionInfo
    };
};
